import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ApiService, Vehicle, Faq } from '../../services/api.service';

@Component({
  selector: 'app-rental',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './rental.component.html'
})
export class RentalComponent implements OnInit {
  vehicles: Vehicle[] = [];
  faqs: Faq[] = [];

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    this.api.getVehicles().subscribe({
      next: (data) => this.vehicles = data,
      error: () => this.loadFallbackVehicles()
    });

    this.api.getFaqs('Rental').subscribe({
      next: (data) => this.faqs = data,
      error: () => this.loadFallbackFaqs()
    });
  }

  private loadFallbackVehicles(): void {
    this.vehicles = [
      { id: 1, assetCode: '8821', name: 'Tesla Model 3', category: 'Car', status: 'Available', location: 'Bay 12', details: '98% Battery', dailyRate: 99, weeklyRate: 599, monthlyRate: 1999 },
      { id: 2, assetCode: 'A-402', name: 'Corner Office', category: 'Property', status: 'Booked', location: 'Floor 4', details: 'Until Jan 15', dailyRate: 150, weeklyRate: 900, monthlyRate: 3500 },
      { id: 3, assetCode: 'EQ-90', name: 'Excavator XH5', category: 'Equipment', status: 'Maintenance', location: 'Service Area', details: 'Hydraulic Check', dailyRate: 250, weeklyRate: 1500, monthlyRate: 5000 },
      { id: 4, assetCode: '1102', name: 'BMW 5 Series', category: 'Car', status: 'Available', location: 'Bay 04', details: 'Cleaned', dailyRate: 119, weeklyRate: 699, monthlyRate: 2499 }
    ];
  }

  private loadFallbackFaqs(): void {
    this.faqs = [
      { id: 1, question: 'Can ZAD ERP manage different unit types like cars and heavy equipment?', answer: 'Yes. Our system is built on a flexible hierarchical structure that allows you to define custom templates for any asset class.', module: 'Rental', sortOrder: 1 },
      { id: 2, question: 'How do dynamic pricing and seasonal surcharges work?', answer: 'The dynamic pricing engine allows you to set rule-based rate cards. You can automate price adjustments based on peak seasons, holidays, or inventory levels.', module: 'Rental', sortOrder: 2 },
      { id: 3, question: 'Is there real-time availability tracking for entire fleets?', answer: 'Absolutely. The Live View dashboard provides a bird\'s-eye perspective of your entire inventory with color-coded statuses.', module: 'Rental', sortOrder: 3 },
      { id: 4, question: 'How are rental invoices integrated with the accounting module?', answer: 'ZAD ERP features native integration. When a rental contract is signed or closed, the system automatically generates an invoice in the Finance module.', module: 'Rental', sortOrder: 4 },
      { id: 5, question: 'Can I set up automated maintenance alerts for my vehicles?', answer: 'Yes. You can configure preventive maintenance schedules based on time intervals, mileage thresholds, or usage hours.', module: 'Rental', sortOrder: 5 }
    ];
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'Available': return 'bg-secondary-container text-on-secondary-container';
      case 'Booked': return 'bg-primary-fixed text-primary';
      case 'Maintenance': return 'bg-error-container text-on-error-container';
      default: return 'bg-surface-container text-on-surface-variant';
    }
  }

  getStatusBarClass(status: string): string {
    switch (status) {
      case 'Available': return 'bg-secondary-container';
      case 'Booked': return 'bg-primary-container';
      case 'Maintenance': return 'bg-error';
      default: return 'bg-surface-container';
    }
  }
}
